import styled from 'styled-components'

export const DropdownWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0 2.5rem 0 1rem;
  height: 3rem;
  border: 0.0625rem solid ${({ theme }) => theme.grey400Color};
  border-radius: 0.25rem;
  background: transparent;
  cursor: pointer;

  &::after {
    content: '';
    position: absolute;
    right: 1rem;
    top: 50%;
    width: 0.5rem;
    height: 0.5rem;
    border-right: 0.125rem solid ${({ theme }) => theme.grey900Color};
    border-bottom: 0.125rem solid ${({ theme }) => theme.grey900Color};
    transform: translateY(-75%) rotate(45deg);
    pointer-events: none;
  }

  &:focus-visible,
  &:focus-within {
    outline: 0.125rem solid ${({ theme }) => theme.primaryColor};
    outline-offset: 0.125rem;
  }
`

export const DropdownLabel = styled.span`
  font-family: Rubik, verdana, sans-serif;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.25rem;
  letter-spacing: 0.0187rem;
  color: ${({ theme }) => theme.grey800Color};
  white-space: nowrap;
`

export const DropdownValue = styled.span`
  flex: 1;
  font-family: Rubik, verdana, sans-serif;
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1.25rem;
  letter-spacing: 0.0187rem;
  color: ${({ theme }) => theme.grey900Color};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const DropdownMenu = styled.ul`
  position: absolute;
  top: calc(100% + 0.25rem);
  left: 0;
  right: 0;
  max-height: 14rem;
  overflow-y: auto;
  margin: 0;
  padding: 0.25rem 0;
  list-style: none;
  background: ${({ theme }) => theme.whiteColor};
  border: 0.0625rem solid ${({ theme }) => theme.grey400Color};
  border-radius: 0.25rem;
  box-shadow: 0 0.25rem 0.625rem 0 rgb(0 0 0 / 8%);
  z-index: 10;

  > li {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 1rem;
    font-family: Rubik, verdana, sans-serif;
    font-size: 0.875rem;
    line-height: 1.25rem;
    letter-spacing: 0.0187rem;
    color: ${({ theme }) => theme.grey900Color};
    cursor: pointer;

    &:hover {
      background: ${({ theme }) => theme.grey100Color};
    }

    &[data-selected='true'] {
      font-weight: 600;
      color: ${({ theme }) => theme.primaryColor};
    }

    &[data-any-item] {
      border-bottom: 0.0625rem solid ${({ theme }) => theme.grey400Color};
      margin-bottom: 0.25rem;
    }
  }
`
